import LazyWrapper from 'bz-core-controls/controls/lazy';
import { lazy } from 'react';
const plugins = {
  //sidebar: [],
  routes: {
    //topLevel: [],
    settings: {
      setup: [LazyWrapper(lazy(() => import('./settings/routes')))]
    }
    //finances: [],
    //contacts: {}
  },

  settingsSetupMenu: [
    LazyWrapper(lazy(() => import('./settings/departments/departments-menu-item')))
  ]
};

export default plugins;
